<template>
  <div class="mso-coupon-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "msoCouponBase",
};
</script>
